<template>
    <div>
        <v-container  v-if="$store.state.menu.Sliders" fill-height
                     fluid
                     grid-list-xl>

            <Loader :loading="loading"/>

            <v-layout justify-center wrap class="background-white">
                <v-flex md12>

                    <v-btn color="primary"

                           @click="getItems(false)"
                           text
                           class="mb-4 mr-2"
                    >Обновить
                    </v-btn>

                    <v-btn color="success"
                           class="mb-4 mr-2"
                           @click="itemDataAddModal=true"
                           text>
                        Добавить
                    </v-btn>


                    <v-data-table :headers="headers"
                                  :items="itemsList"
                                  hide-actions
                    >
                        <template slot="headerCell"
                                  slot-scope="{ header }">

              <span class="subheading font-weight-light text-success text--darken-3"
                    v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ item }">
                            <td class="text-xs-left">
                                <b>{{ item.id }}</b>
                            </td>
                            <td class="text-xs-left">
                                    <span class="text-warning"
                                          v-if="item.is_active && item.is_active===1">Да
                                    </span>
                                <span class="text-warning" v-else>Нет
                                    </span>
                            </td>
                            <td class="text-xs-left min-width">
                                <span class="user-link">{{item.title}}</span>
                            </td>
                            <td class="text-xs-left min-width">
                                <span v-if="item.resource">{{item.resource.name}}</span>
                                <span v-else>Ресурс не установлен</span>
                            </td>
                            <td class="text-xs-right  relative ">

                    <v-icon class="mr-3" @click="openItem(item.id)">mdi-pencil</v-icon>

                                <v-icon class="mr-2 text-danger" @click="removeItem(item.id)">
                                    mdi-close
                                </v-icon>
                            </td>
                        </template>
                    </v-data-table>

                    <v-pagination
                            v-if="last_page>1"
                            v-model="page"
                            class="my-4"
                            :length="last_page"
                    ></v-pagination>

                </v-flex>
            </v-layout>
        </v-container>

        <v-dialog v-model="item"
                  v-if="item"
                  persistent
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition">
            <Slide :slide="item"
                   :closePage="closePage"/>
        </v-dialog>


        <v-dialog width="600"
                  v-model="itemDataAddModal">
            <v-card>
                <v-card-text>
                    <v-text-field
                            label="Метка"
                            placeholder="Введите метку"
                            v-model="title"
                            outlined
                    ></v-text-field>
                </v-card-text>
                <v-divider>
                </v-divider>
                <v-card-actions class="text-xs-center">
                    <v-btn color="success"
                           text
                           @click="addData">Сохранить
                    </v-btn>
                    <v-btn color="primary"
                           text
                           @click="itemDataAddModal=false">Отмена
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </div>
</template>

<script>


    import Loader from "../components/helper/Loader";
    import Slide from "../components/core/Sliders/Slide";

    import {mapState} from 'vuex';

    export default {
        data: () => ({
            item: null,
            loadingSet: false,
            itemDataAddModal: false,
            title: '',
            page: 1,
            searcher: null,
            loading: true,
            last_page: 0,
            headers: [
                {
                    sortable: false,
                    text: 'ID',
                    value: 'id'
                },
                {
                    sortable: false,
                    text: 'Активен',
                    value: 'dealer.name'
                },
                {
                    sortable: false,
                    text: 'Метка',
                    value: 'dealer.name'
                },
                {
                    sortable: false,
                    text: 'Ресурс',
                    value: 'dealer.name'
                },
                {
                    sortable: false,
                    text: '',
                    value: '',
                    align: 'right'
                }
            ],
            itemsList: [],
        }),
        components: {Slide, Loader},

        methods: {

            async getItems(noLoading) {

                let ID = null;
                if (this.item) {
                    ID = this.item.id;
                }

                this.item = null;

                if (!noLoading) {
                    this.loading = true;
                }
                await  axios.get('admin/sliders/list', {
                    params: {
                        page: this.page,
                    }
                }).then(response => {
                    this.itemsList = response.data.data;
                    this.last_page = response.data.last_page;

                    if (response.data.data &&
                        response.data.data.length && ID) {
                        this.openItem(ID);
                    }

                }).catch(error => {
                }).finally(() => {
                    this.loading = false;

                });
            },
            openItem(itemID) {
                if (itemID) {
                    setTimeout(() => {
                        this.item = this.itemsList
                            .filter(x => x.id === itemID)
                            [0];
                    }, 10);
                }
            },
            addData() {
                this.loading = true;
                if (this.title) {
                    axios.post('admin/sliders/set', {
                        title: this.title
                    }).then(response => {
                        this.item = response.data;
                    }).catch(error => {
                        let data = error.response.data;
                        if (data.errors) {
                            let k = 0;
                            Object.keys(data.errors).forEach((item) => {
                                let err = data.errors[item];
                                k++;
                                for (let i = 0; i < err.length; i++) {
                                    setTimeout(() => {
                                        this.$toast.error({
                                            title: 'Ошибка',
                                            message: err[i]
                                        })
                                    }, 100 * k);
                                }
                            });
                        }
                    }).finally(() => {
                        this.itemDataAddModal = false;
                        this.title = '';
                        this.loading = false;
                    });

                } else {
                    this.$toast.error({
                        title: 'Название',
                        message: 'Введите метку'
                    });

                    this.loading = false;
                }
            },

            removeItem(itemID) {
                if (itemID) {
                    this.$dialog
                        .confirm('Вы точно хотите удалить?', {
                            okText: 'Удалить',
                            cancelText: 'Отмена'
                        })
                        .then(() => {
                            this.loading = true;
                            axios.delete('admin/sliders/delete', {
                                data: {
                                    id: itemID,
                                }
                            }).then(response => {
                                    this.$toast.success({
                                        title: 'Удаление',
                                        message: 'Поле удалено с сервера'
                                    });
                                    this.getItems(true);
                                }
                            ).catch(error => {
                                this.$toast.error({
                                    title: 'Удаление',
                                    message: 'Ошибка удаления'
                                });
                            }).finally(() => {
                                this.loading = false;
                                this.getItems();
                            });

                        })
                        .catch(() => {

                        });
                }
            },

            closePage(set) {
                this.item = null;
                if (set) {
                    this.getItems();
                }
            }
        },
        watch: {
            page() {
                setTimeout(() => {
                    this.getItems();
                }, 300)
            },
            language(val) {
                if (val) {
                    this.getItems();
                }
            }
        },
        computed: {
            ...mapState(['language'])
        },
        mounted() {
            this.getItems();
        }
    }
</script>
